/**
 * Raw / processed classification for a FOUP, derived only from the stream.
 *
 * Stockers get this for free from their `raw` / `processed` columns, but a FOUP
 * riding an OHT has no column of its own — the renderers only know *that* the
 * vehicle is loaded. The pickup that put it there does carry the answer, so the
 * scheduler resolves the kind once at pickup and holds it until the drop.
 */
import type { AmhsTransferFrame, LiveFoupKind } from '../../types/amhsStream';

/** Kind the OHT is carrying after `frame`, which must be a PICKUP. */
export function resolvePickupFoupKind(frame: AmhsTransferFrame): LiveFoupKind {
  const column = frame.column?.trim().toLowerCase();
  if (column === 'processed') return 'processed';
  // Some streams label the incoming column `new` rather than `raw`.
  if (column === 'raw' || column === 'new') return 'raw';

  const portKind = frame.portKind?.trim().toUpperCase();
  if (portKind === 'ENTRY_GATE') return 'raw';
  if (portKind === 'EXIT_GATE') return 'processed';

  // A carrier collected from a process tool has been through that tool; only a
  // drop puts a raw carrier on one.
  if (frame.toolId?.trim()) return 'processed';

  return 'raw';
}
